import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'components/Grid';
import { ContentMedia } from '../ContentMedia';
import { cx } from 'utility';
import * as styles from './ContentMediaList.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: PropTypes.array,
    titleFontSize: PropTypes.number,
};

const defaultProps = {
    className: '',
    items: [],
    titleFontSize: 8,
};

function getClasses({ className }) {
    const classes = cx(
        className,
        styles['contentMediaList'],
    );

    return classes || undefined;
}

function ContentMediaList({
    className,
    items,
    titleFontSize,
}) {
    const classes = getClasses({ className });

    return (
        <div className={classes}>
            <Grid>
                <div className={styles['container']}>
                    {items.map(({ content_media_alignment, content_media_button_color, content_media_button_style, content_media_button_text, content_media_button_url, content_media_content, content_media_image, content_media_title, content_media_video_autoplay, content_media_video_embed_title, content_media_video_embed_url, content_media_video_upload_url }, index) => {
                        const alignment = content_media_alignment;
                        const buttonColor = content_media_button_color?.text;
                        const buttonStyle = content_media_button_style?.text;
                        const buttonText = content_media_button_text?.text;
                        const buttonUrl = content_media_button_url;
                        const content = content_media_content?.text;
                        const image = content_media_image;
                        const title = content_media_title?.text;
                        const videoAutoplay = content_media_video_autoplay;
                        const videoEmbedTitle = content_media_video_embed_title?.text;
                        const videoEmbedUrl = content_media_video_embed_url?.html;
                        const videoUploadUrl = content_media_video_upload_url;

                        return (
                            <ContentMedia
                                key={`content-media-item-${index}`}
                                alignment={alignment}
                                buttonColor={buttonColor}
                                buttonStyle={buttonStyle}
                                buttonText={buttonText}
                                buttonUrl={buttonUrl}
                                className={styles['item']}
                                content={content}
                                gridClassName={styles['grid']}
                                image={image}
                                title={title}
                                titleFontSize={titleFontSize}
                                videoAutoplay={videoAutoplay}
                                videoEmbedTitle={videoEmbedTitle}
                                videoEmbedUrl={videoEmbedUrl}
                                videoUploadUrl={videoUploadUrl}
                            />
                        );
                    })}
                </div>
            </Grid>
        </div>
    );
}

ContentMediaList.propTypes = propTypes;
ContentMediaList.defaultProps = defaultProps;

export { ContentMediaList };
